module.exports = __webpack_public_path__ + "static/media/starwars-demo.9d251593.gif";